export const NO_IMAGE_AVAILABLE_ID = 'bb_brandless_no_image_available_thumbnail'

export const PARTNERSHIP_LOGO_ASPECT_RATIO = 330 / 235

export const DEFAULT_CUSTOM_OFFER_FLIGHT_IMAGE_ID = '317feff5-7206-4f61-8786-c47591c49f68'

export const DEFAULT_AIRPORT_TRANSFER_IMAGE_ID = 'cars-page-transfer-how-it-works-driver'
